$shm_showcase_demo_check_list $mol_list
	rows /
		<= Input $shm_check_list
			options /
				\Почта
				\Уведомления
				\Отчёты
			value? => selected?
		<= Selected $mol_text
			text <= summary \
